import React, { ReactNode, useState } from "react";
import { Box, ThemeUIStyleObject } from "theme-ui";
import { primaryColorScales } from "../theme/styles/colors";
import { renderToStaticMarkup } from "react-dom/server";
import ArrowDown from "../images/arrowDown";

type Props = {
  children?: ReactNode;
  onChange: React.FormEventHandler<HTMLDivElement> | undefined;
  sx?: ThemeUIStyleObject | undefined;
  name?: string;
  id?: string;
};

export const Select: React.FC<Props> = ({
  children,
  onChange,
  sx,
  name,
  id,
}) => {
  const [rotateNumber, setRotateNumber] = useState(0);

  const svgArrowDownString = encodeURIComponent(
    renderToStaticMarkup(<ArrowDown />),
  );

  const clickedSelect = () => {
    setRotateNumber((prevRotateNumber) => prevRotateNumber + 180);
  };

  return (
    <Box
      as="div"
      sx={{
        position: "relative",
        "::before": {
          content: '""',
          height: "40px",
          width: "40px",
          position: "absolute",
          right: "0px",
          top: "50%",
          pointerEvents: "none",
          transition: "transform 0.3s",
          transform: `translate(-50%, -50%) rotate(${rotateNumber}deg)`,
          background: `center no-repeat url('data:image/svg+xml;utf8, ${svgArrowDownString}')`,
        },
      }}
    >
      <Box
        as="select"
        //@ts-ignore
        name={name}
        id={id}
        onClick={() => clickedSelect()}
        onBlur={() => {
          if (rotateNumber % 360 === 180) {
            setRotateNumber(rotateNumber + 180);
          }
        }}
        onChange={onChange}
        sx={{
          ...sx,
          height: "44px",
          borderRadius: "0",
          appearance: "none",
          outline: "none",
          border: `0.0625rem solid ${primaryColorScales.blueScale[3]}`,
          ":hover": {
            cursor: "pointer",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
